import React, { Component, Fragment } from 'react';
import ScrollLock from 'react-scrolllock';

import Header from '../NewProfile/Header';
import SideBarContent from '../SideBar/SideBarContent';
import Button from '../../artzu-ui/src/Button';

class BasicComponent extends Component {
  render() {
    const { id, history, status, email, operatingCity } = this.props;
    return (
      <div className="intro container new-course">
        {/introapp/.test(window.location.href) ? null : (
          <Header
            persistentTitle
            title="The Basics"
            back
            onClick={() => {
              history.goBack();
            }}
          />
        )}
        <div className="new-course__body__footer--mobile">
          <div className="new-course__body__buttons">
            {/introapp/.test(window.location.href) ? (
              <a href="/dashboard">
                <Button label="Dashboard" size="xl" padding="0" />
              </a>
            ) : (
              <Button
                label="Dashboard"
                size="xl"
                padding="0"
                onClick={() => history.push('/dashboard')}
              />
            )}
            {/introapp/.test(window.location.href) ? (
              <a href={`/introapp/${Number(id) + 1}`}>
                <Button primary label="Next" size="xl" padding="0" />
              </a>
            ) : (
              <Button
                primary
                label="Next"
                size="xl"
                padding="0"
                onClick={() => history.push(`/intro/${Number(id) + 1}`)}
              />
            )}
          </div>
        </div>
        <ScrollLock>
          <div className="intro__content new-course__container">
            <div className="intro__sidebar new-course__sidebar">
              <SideBarContent status={status} signedIn={email} />
            </div>
            <div
              className="new-course__body"
              style={
                /introapp/.test(window.location.href)
                  ? { marginTop: '0' }
                  : null
              }>
              <div className="intro__content--container">
                <div className="intro__content__title">
                  Welcome to Autzu!
                </div>
                <div className="intro__content__para">
                  You are now ready to take part in drivesharing! No need
                  to worry about maintenance and car insurance - just book,
                  drive, and earn.
                </div>
                <br />
                <div className="intro__content__title">How it Works</div>
                <div className="intro__content__para">
                  Book online at www.autzu.com for the times and dates you
                  want to drive.{' '}
                </div>
                <div className="intro__content__para">
                  When your booking is about to start, the system will
                  automatically assign you a vehicle, and you will get that
                  information by text message and in your Autzu Dashboard.
                </div>
                <div className="intro__content__para">
                  Get to the parking lot, inspect your car, and contact us
                  if you need any assistance.
                </div>
                {operatingCity === 'new_york' ? (
                  <div className="intro__content__para">
                    When you’re ready to drive, log on to the Via Driver
                    App. Make sure you’re using the correct license plate
                    in the app, and then go online to start earning.
                  </div>
                ) : (
                  <div className="intro__content__para">
                    When you’re ready to drive, log on to the Uber Driver
                    App. Make sure you’re using the correct license plate
                    in the app, and then go online to start earning.
                  </div>
                )}
                {operatingCity === 'new_york' ? (
                  <div className="intro__content__para">
                    Finally, return the car on time and with a full tank of
                    gas.
                  </div>
                ) : (
                  <div className="intro__content__para">
                    Finally, return the car on time and with a full tank of
                    gas. Don’t forget to go offline in the Uber Driver app.
                  </div>
                )}
                <br />
                <div className="intro__content__title">
                  Earnings and Payments
                </div>
                {operatingCity === 'new_york' ? (
                  <div className="intro__content__para">
                    The fees for your Autzu bookings are deducted
                    automatically each week from your Via earnings.
                  </div>
                ) : (
                  <div className="intro__content__para">
                    Payments are deposited weekly on Wednesdays directly to
                    your bank account. You will receive a week’s worth of
                    earnings, which are your Total Uber Earnings minus any
                    Autzu Fees.
                  </div>
                )}
                <br />
                <br />
                <br />
              </div>
              <div className="new-course__body__footer--desktop intro__content__footer--desktop">
                <div className="new-course__body__buttons intro__content__footer--buttons">
                  <Button
                    color="#414141"
                    label="Dashboard"
                    size="xl"
                    onClick={() => history.push('/dashboard')}
                  />
                  <Button
                    primary
                    label="Next"
                    size="xl"
                    onClick={() =>
                      history.push(`/intro/${Number(id) + 1}`)
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </ScrollLock>
      </div>
    );
  }
}

export default BasicComponent;



// WEBPACK FOOTER //
// ./src/components/Intro/BasicComponent.js